import { Separator } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import {
  useOtherArticlesByCategory,
  useRelatedArticlesByCategory,
} from 'libs/client/api'
import ArticleTiles from './ArticleTiles'
import OtherArticles from './OtherArticles'

const RelatedArticles = () => {
  const { article } = useStaticData()
  const { relatedArticlesByCategory } = useRelatedArticlesByCategory(
    article.category.id,
  )
  const { otherArticlesByCategory, error: otherArticlesError } =
    useOtherArticlesByCategory(article.category.id)

  return (
    <section className='container mc-py-10' data-testid='related-articles'>
      <Separator className='mc-my-0' />
      <div className='row mc-mt-10'>
        <div className='col-12 col-md-8 col-lg-9'>
          <ArticleTiles articles={relatedArticlesByCategory} />
        </div>
        {otherArticlesByCategory && !otherArticlesError && (
          <OtherArticles articles={otherArticlesByCategory} />
        )}
      </div>
    </section>
  )
}

export default RelatedArticles
